/**
 * 呼び出し元画面の入力情報を格納するVO
 *
 */
export class KYMW1900InputModel {

  /**
   * 開始受付番号
   */
  public receiptNumFrom: string = <string>'';

  /**
   * 終了受付番号
   */
  public receiptNumTo: string = <string>'';

  /**
   * 部門コード
   */
  public classCode: string = <string>'';

  /**
   * 商品名
   */
  public subject: string = <string>'';

  /**
   * 問合せ内容
   */
  public inquiryContents: string = <string>'';

  /**
   * 開始会員受付日
   */
  public receiptDateFrom: string = <string>'';

  /**
   * 終了会員受付日
   */
  public receiptDateTo: string = <string>'';

  /**
   * 掲載区分
   */
  public publishType: string = <string>'0';

  /**
   * 生協コード
   */
  public coopCode: string = <string>'';

  /**
   * 開始PEACE取込日
   */
  public importDateFrom: string = <string>'';

  /**
   * 終了PEACE取込日
   */
  public importDateTo: string = <string>'';

}
